import { ColumnDef } from "@tanstack/react-table"

import { MeterStatusType } from "@/types/meter"

import { DataTableColumnHeader } from "../../data-table"
import { Button } from "../../ui/button"
import { MeterStatusOperation } from "../operations/meter-status-operations"

export const meterStatusColumns: ColumnDef<MeterStatusType>[] = [
  {
    accessorKey: "meter_status_id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
    cell: ({ row }) => {
      const value = row.original.meter_status_id
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => {
      const value = row.original.name
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "description",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Description" />
    ),
    cell: ({ row }) => {
      const value = row.original.description
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "sequence",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Sequence" />
    ),
    cell: ({ row }) => {
      const value = row.original.sequence
      return <div>{value}</div>
    },
  },

  {
    accessorKey: "icon",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Icon" />
    ),
    cell: ({ row }) => {
      const value = row.original.icon
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "actions",
    header: () => {
      return <div className="text-center dark:text-white">Actions</div>
    },
    cell: ({ row }) => {
      return (
        <div className="px-4 py-2 text-center md:py-0 md:text-center">
          <MeterStatusOperation data={row.original} />
        </div>
      )
    },
  },
]
